import MyInput from '../../../components/ui/MyInput';
import { useEffect, useState } from 'react';
import PrimaryButton from '../../../components/ui/PrimaryButton';
import {
    SVG_Add_Square_Bold,
    SVG_Traffic_Bold,
    SVG_Trash_Bin_2_Bold,
    SVG_Trash_Bin_2_Linear,
    SVG_Trash_Bin_2_Outline,
    SVG_Trash_Bin_Minimalistic_2_Bold,
} from '@dev-mobligo/iconpack';
import { useDispatch } from 'react-redux';
import systemSlice from '../../../redux/systemSlice';
import LayeredDashboardHeader from '../../LayeredDashboardHeader';
import { useNavigate } from 'react-router-dom';
import allTabs from '../../DashboardTabs';
import CreateAction from '../../../components/operational/createAction';
import useCustomNavigate from '../../../components/operational/goBack';

import ikasLogo from '../../../assets/img/ikas.png';
import shopier from '../../../assets/img/shopier.png';
import shopify from '../../../assets/img/shopify.png';
import wix from '../../../assets/img/wix.png';
import ticimax from '../../../assets/img/ticimax.png';
import tSoft from '../../../assets/img/tsoft.png';
import ideasoft from '../../../assets/img/ideasoft.jpg';
import wooCommerce from '../../../assets/img/woocommerce.png';
import Webview from '../../../assets/img/webview.png';
import Card from '../../ChooseAppPage/OnBoarding/Card';
import FileUploader from '../../../components/ui/FileUploader';
import { JSONValidator } from '../../../helper/Validators';
import FirebaseIntegrationsItem from './FirebaseIntegrationsItem';
import { urlToFileName } from '../../../helper/Converters';

const IntegrationsFirebase = ({ tab }) => {

    const [firebaseData, setFirebaseData] = useState({
        "service_account": null,
        "android_service_account": null,
        "ios_service_account": null
    })
    const [propertyId, setPropertyId] = useState("")

    const updateFirebaseData = (key, value) => {
        setFirebaseData(state => ({ ...state, [`${key}`]: value }))
    }
    const navigate = useNavigate();
    const getClientData = async () => {
        const response = await CreateAction({
            method: 'get',
            path: `/integrations/firebaseaccount`,
            showPreLoader: true,
            isFileUploading: false,
        });

        if (response?.error) {
            return navigate('/dashboard/');
        }
        const resultData = response?.result?.resultData
        setFirebaseData(
            {
                "service_account": { name: urlToFileName(resultData?.["service_account"]) },
                "android_service_account": { name: urlToFileName(resultData?.["android_service_account"]) },
                "ios_service_account": { name: urlToFileName(resultData?.["ios_service_account"]) }
            }
        )

    };
    const getPropertyId = async () => {
        const response = await CreateAction({
            method: 'get',
            path: `/integrations/propertyId`,
            showPreLoader: true,
            isFileUploading: false,
        });

        if (response?.error) {
            return navigate('/dashboard/');
        }
        const resultData = response?.result?.resultData
        setPropertyId(resultData?.propertyId)

    };

    const uploadClientData = async (key, fileData) => {
        if (!fileData) return
        const formData = new FormData();
        formData.append(key, fileData);  // Append the file to FormData

        const response = await CreateAction({
            method: 'post',
            path: `/integrations/firebaseaccount`,
            showPreLoader: true,
            isFileUploading: false,
            data: formData
        });
        if (response.error) return;

        updateFirebaseData(key, fileData)

    };
    const uploadPropertyId = async () => {
        if (!propertyId) return
        const response = await CreateAction({
            method: 'post',
            path: `/integrations/propertyId`,
            showPreLoader: true,
            isFileUploading: false,
            data: {
                propertyId
            }
        });
        if (response.error) return;

    };

    useEffect(() => {
        getClientData();
        getPropertyId()
    }, []);


    return (
        <>
            <LayeredDashboardHeader tab={tab} ></LayeredDashboardHeader>
            <div className="w-full h-[calc(100dvh-70px)] overflow-auto scrollbar-y-visible">
                <div>
                    <div className="p-[20px] flex items-center justify-center 2xl:p-[40px] flex-col max-w-[1120px] mx-auto gap-[20px]">
                        <div className='py-[40px] gap-[15px] flex flex-col items-center'>
                            <div className='text-bold text-[32px] text-black'>Veri İzleme ve Analiz Araçları</div>
                            <div className='text-bold text-[20px] text-[#667588]'>Entegrasyonlarınızı tamamlayın.</div>
                        </div>

                        <FirebaseIntegrationsItem firebaseData={firebaseData} onFileUpload={uploadClientData} onUploadName={"service_account"} acceptedTypes={[".json"]} header={"Firebase Service Account"} description={"Firebase servis hesabınızın dosyası"} />
                        <FirebaseIntegrationsItem icon={<img src="https://mobligo-bucket.s3.eu-central-1.amazonaws.com/android-removebg-preview.png" width={45} height={45} alt="Android Logo" />} firebaseData={firebaseData} onFileUpload={uploadClientData} onUploadName={"android_service_account"} acceptedTypes={[".json"]} header={"Firebase Android Service Account"} description={"Firebase servis hesabınızın dosyası"} />
                        <FirebaseIntegrationsItem icon={<img src="https://mobligo-bucket.s3.eu-central-1.amazonaws.com/ios%2B-removebg-preview.png" width={45} height={45} alt="Android Logo" />} firebaseData={firebaseData} onFileUpload={uploadClientData} onUploadName={"ios_service_account"} acceptedTypes={[".plist"]} header={"Firebase IOS Service Account"} description={"Firebase servis hesabınızın dosyası"} />
                        <div className="bg-white p-[20px] rounded-[10px] max-w-[1120px] w-[100%] flex flex-row  items-center "  >
                            <MyInput type={"number"} value={propertyId} onChange={setPropertyId} classes={"max-w-[500px]"} label="Mülk No" placeholder={"Mülk No"} />
                            <PrimaryButton onClick={uploadPropertyId} classes='mt-[] h-[40px] shrink-0  !w-[150px] ml-auto' value={"Kaydet"}>

                            </PrimaryButton>
                        </div>

                    </div>

                </div>
            </div>
        </>
    );
};

export default IntegrationsFirebase;
